import React, { useEffect, useState } from 'react';
import { Container, Typography, Grid, Paper, Button, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import axiosInstance from '../../services/api';

const AdminProductSubTypes = () => {
  const [subTypes, setSubTypes] = useState([]);

  useEffect(() => {
    fetchSubTypes();
  }, []);

  const fetchSubTypes = async () => {
    try {
      const response = await axiosInstance.get('/productsubtypes');
      setSubTypes(response.data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Bu ürünü silmek istediğinize emin misiniz?")) return;
    try {
      await axiosInstance.delete(`/productsubtypes/${id}`);
      fetchSubTypes();
    } catch (err) {
      console.error(err);
    }
  };

  return (
 
      <Container>
        <Box sx={{ my: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h4">Ürün Alttipleri Yönetimi</Typography>
          <Button variant="contained" color="primary" component={Link} to="/admin/productsubtypes/new">
            Yeni Ürün Alttipi Ekle
          </Button>
        </Box>
        <Grid container spacing={2}>
          {subTypes.map((sub) => (
            <Grid item xs={12} sm={6} md={4} key={sub.id}>
              <Paper sx={{ p: 2 }}>
                <Typography variant="h6">{sub.name}</Typography>
                <Typography variant="body2">{sub.description}</Typography>
                <Typography variant="body2">
                  Ürün Tipi: {sub.productTypeDto ? sub.productTypeDto.name : 'Belirtilmemiş'}
                </Typography>
                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between' }}>
                  <Button variant="outlined" component={Link} to={`/admin/productsubtypes/edit/${sub.id}`}>
                    Düzenle
                  </Button>
                  <Button variant="outlined" color="error" onClick={() => handleDelete(sub.id)}>
                    Sil
                  </Button>
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>

  );
};

export default AdminProductSubTypes;
